import { FC } from 'react';

import BaseSkeleton from '../BaseSkeleton';

const ChartSkeleton: FC = (): JSX.Element => {
    return (
        <div style={{ margin: '0 0.75rem' }}>
            <BaseSkeleton paragraph={{ rows: 6 }} />
        </div>
    );
};

export default ChartSkeleton;
